import BiMap from 'bidirectional-map';

export class BiMapWithDefaults<V> extends BiMap<V> {
  private defaultKey?: string;
  private defaultValue?: V;

  constructor(data: Record<string, V>, defaultKey?: string, defaultValue?: V) {
    super(data);
    this.defaultKey = defaultKey;
    this.defaultValue = defaultValue;
  }

  get(key: string): V {
    const result = super.get(key);
    if (result !== undefined) {
      return result;
    }
    if (this.defaultValue !== undefined) {
      return this.defaultValue;
    }
    throw new Error(`Key "${key}" not found in BiMap and no default value provided`);
  }

  getKey(value: V): string {
    const result = super.getKey(value);
    if (result !== undefined) {
      return result;
    }
    if (this.defaultKey !== undefined) {
      return this.defaultKey;
    }
    throw new Error(`Value "${value}" not found in BiMap and no default key provided`);
  }
}